




































































































































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AccomodationUnitTypeViewModel } from "@/shared/models/accomodationUnitTypeViewModel";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import PriceInput, { PriceChange } from "../../calendar/inputs/PriceInput.vue";
import {
  OfficialRateModel,
  OfficialRateRuleModel,
  OfficialRateRulesGroupingEnum,
} from "./types";
import { formatLocaleNumber } from "@/components/numbers/numberFormatUtils";
import { enumToArray } from "@/shared/commonFunctions";
import * as _ from "lodash";
import { OwnerPricingModelEnum } from "@/shared/models/enums.type";
import { autoCalculatePrice, calculatePrice, round } from "@/components/numbers/numberFormatUtils";

export interface RulesGroup {
  minPersons: number | null;
  maxPersons: number | null;
  minStay: number | null;
  maxStay: number | null;
  isDefaultLOSCategory: boolean;
  isDefaultPAXCategory: boolean;
  losCategoryId: number | null;
  paxCategoryId: number | null;
  inputPriceDifference?: number | null;
  inputPriceDifferenceIsAbsolute?: boolean | null;
  outputPriceDifference?: number | null;
  outputPriceDifferenceIsAbsolute?: boolean | null;
}

@Component({
  components: {
    NumericInputImproved,
    PriceInput,
  },
})
export default class OfficialRatesOBAndLOSRules extends Vue {
  @PropSync("officialRate") officialRateInternal?: OfficialRateModel;
  @PropSync("saving") savingInternal?: boolean;
  @Prop() accUnitType?: AccomodationUnitTypeViewModel;
  @Prop({ default: OfficialRateRulesGroupingEnum.ByLengthOfStay })
  grouping?: OfficialRateRulesGroupingEnum;

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;

  @Getter("language/language") language?: string;

  enumToArray = enumToArray;
  expanded = [] as number[];
  automaticCalculationModal = false;

  toggleExpandCollapse() {
    if (this.expanded.length === this.rulesGroups.length) {
      this.expanded = [];
    } else {
      for (let i = 0; i < this.rulesGroups.length; i++) {
        if (!this.expanded.includes(i)) {
          this.expanded.push(i);
        }
      }
    }
  }

  officialRateRulesGroupingEnum = OfficialRateRulesGroupingEnum;

  get rulesGroups() {
    const mapped =
      this.officialRateInternal?.officialRateRules.map((x) => {
        return {
          minPersons: x.minPersons,
          maxPersons: x.maxPersons,
          minStay: x.minStay,
          maxStay: x.maxStay,
          isDefaultLOSCategory: x.isDefaultLOSCategory,
          isDefaultPAXCategory: x.isDefaultPAXCategory,
          losCategoryId: x.accomodationUnitTypesLOSCategoryId,
          paxCategoryId: x.accomodationUnitTypesPAXCategoryId,
          noSales: x.noSales,
        } as RulesGroup;
      }) ?? [];

    if (this.grouping === OfficialRateRulesGroupingEnum.ByOccupancy) {
      return _.uniqBy(mapped, (x) => x.minPersons);
    } else {
      return _.uniqBy(mapped, (x) => x.minStay);
    }
  }

  getGroupHeader(group: RulesGroup) {
    if (this.grouping === OfficialRateRulesGroupingEnum.ByOccupancy) {
      return group.minPersons === group.maxPersons
        ? `${group.minPersons} pax`
        : `${group.minPersons}-${group.maxPersons} pax`;
    }

    return (group.maxStay ?? 0) > 0
      ? `${group.minStay}-${group.maxStay} nights`
      : `${group.minStay}+ nights`;
  }

  getRuleHeader(obr: OfficialRateRuleModel) {
    if (this.grouping === OfficialRateRulesGroupingEnum.ByLengthOfStay) {
      return obr.minPersons === obr.maxPersons
        ? `${obr.minPersons} pax`
        : `${obr.minPersons}-${obr.maxPersons} pax`;
    }

    return (obr.maxStay ?? 0) > 0
      ? `${obr.minStay}-${obr.maxStay} nights`
      : `${obr.minStay}+ nights`;
  }

  getGroupRules(group: any) {
    if (this.grouping === OfficialRateRulesGroupingEnum.ByOccupancy) {
      return this.officialRateInternal?.officialRateRules.filter(
        (x) => x.accomodationUnitTypesPAXCategoryId === group.paxCategoryId
      );
    }

    return this.officialRateInternal?.officialRateRules.filter(
      (x) => x.accomodationUnitTypesLOSCategoryId === group.losCategoryId
    );
  }

  get baseCategory() {
    const toReturn = (this.officialRateInternal?.officialRateRules ?? []).find(
      (x) =>
        x.isDefaultLOSCategory && x.isDefaultPAXCategory
    );

    return toReturn ?? null;
  }

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get isPricingModelRelative() {
    return (
      this.accUnitType?.propertyOwnerPricingModelId ==
      OwnerPricingModelEnum.Relative
    );
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      zeroOrPositive: (value: any) =>
        value >= 0 || this.$t("Validation.MustBeZeroOrPositive"),
      undefinedOrPositive: (value: any) =>
        value === undefined ||
        value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
    };
  }

  fkey = 0;
  rowKey = 0;

  formatPrice(price?: number) {
    return price != null
      ? formatLocaleNumber(price, 2, this.internalLanguage)
      : "";
  }

  //if user changes 'inputPrice' -> 'priceReference' is outputPrice to calculate from (and the other way around)
  calculatePrice(priceChange: PriceChange, uniqueKey: string, isMain: boolean, userChangedInputPrice: boolean, priceReference?: number) {
      const changeKey = calculatePrice(
        priceChange,
        this.officialRateInternal,
        userChangedInputPrice,
        priceReference,
        { isMain, uniqueKey }
      );

      if (changeKey) this.fkey++;
    }

  automaticCalculation(isInputPriceChanged: boolean, uniqueKey: string) {
    autoCalculatePrice(
      isInputPriceChanged,
      this.officialRateInternal,
      this.accUnitType?.propertyOwnerPayoutPercent ?? 0,
      undefined,
      uniqueKey
    );
  }

  //used in automatic calculation dialog to calculate all prices based on price differences of every category
  autoCalculateAllPrices(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxInputPricePart = 0;
          let paxOutputPricePart = 0;
          let losInputPricePart = 0;
          let losOutputPricePart = 0;

          if (obr.inputPrice){
            if (
              item.obInputPriceDifference &&
              this.tenantUsesInputPrice &&
              obr.accomodationUnitTypesPAXCategoryId !==
                item.accomodationUnitTypesPAXCategoryId
            ) {
              paxInputPricePart = item.obInputPriceDifferenceIsAbsolute
                ? item.obInputPriceDifference
                : round(obr.inputPrice * (item.obInputPriceDifference / 100));
            }
            if (
              item.losInputPriceDifference &&
              this.tenantUsesInputPrice &&
              obr.accomodationUnitTypesLOSCategoryId !==
                item.accomodationUnitTypesLOSCategoryId
            ) {
              losInputPricePart = item.losInputPriceDifferenceIsAbsolute
                ? item.losInputPriceDifference
                : round(obr.inputPrice * (item.losInputPriceDifference / 100));
            }
          }
          const inputPriceSum = paxInputPricePart + losInputPricePart // we do this because javascript is dumb :) (123,47 + (-12,35) + (-12,35) = 98,770000000000001 BUT 123,47 + (-24,7) = 98,77)
          item.inputPrice = round((obr.inputPrice ?? 0) + inputPriceSum); // rounding just to avoid further unexpected behavior.

          if (obr.price){
            if (
              item.obOutputPriceDifference &&
              obr.accomodationUnitTypesPAXCategoryId !==
                item.accomodationUnitTypesPAXCategoryId
            ) {
              paxOutputPricePart = item.obOutputPriceDifferenceIsAbsolute
                ? item.obOutputPriceDifference
                : round(obr.price * (item.obOutputPriceDifference / 100));
            }

            if (
              item.losOutputPriceDifference &&
              obr.accomodationUnitTypesLOSCategoryId !==
                item.accomodationUnitTypesLOSCategoryId
            ) {
              losOutputPricePart = item.losOutputPriceDifferenceIsAbsolute
                ? item.losOutputPriceDifference
                : round(obr.price * (item.losOutputPriceDifference / 100));
            }
          }
          const outputPriceSum = paxOutputPricePart + losOutputPricePart; // we do this because javascript is dumb :) (123,47 + (-12,35) + (-12,35) = 98,770000000000001 BUT 123,47 + (-24,7) = 98,77)
          item.price = round((obr.price ?? 0) + outputPriceSum); // rounding just to avoid further unexpected behavior.

          this.fkey++;
          this.rowKey++;
        }
      }
    }

    this.closeModal();
  }

  //when pricing model = relative
  //calculate all prices based on input prices price differences
  autoCalculateFromInputPrice(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxInputPricePart = 0;
          let losInputPricePart = 0;

          if (obr.inputPrice){
            if (
              item.obInputPriceDifference &&
              this.tenantUsesInputPrice &&
              obr.accomodationUnitTypesPAXCategoryId !==
                item.accomodationUnitTypesPAXCategoryId
            ) {
              paxInputPricePart = item.obInputPriceDifferenceIsAbsolute
                ? item.obInputPriceDifference
                : round(obr.inputPrice * (item.obInputPriceDifference / 100));
            }
            
            if (
              item.losInputPriceDifference &&
              this.tenantUsesInputPrice &&
              obr.accomodationUnitTypesLOSCategoryId !== item.accomodationUnitTypesLOSCategoryId
            ) {
              losInputPricePart = item.losInputPriceDifferenceIsAbsolute
                ? item.losInputPriceDifference
                : round(obr.inputPrice * (item.losInputPriceDifference / 100));
            }
          }

          const inputPriceSum = paxInputPricePart + losInputPricePart // we do this because javascript is dumb :) (123,47 + (-12,35) + (-12,35) = 98,770000000000001 BUT 123,47 + (-24,7) = 98,77)
          item.inputPrice = round((obr.inputPrice ?? 0) + inputPriceSum); // rounding just to avoid further unexpected behavior.

          const ownerPayoutPercent = this.accUnitType?.propertyOwnerPayoutPercent ?? 100;
          if (ownerPayoutPercent === 0) {
            item.price = 0;
          } else {
            item.price = round(item.inputPrice / (ownerPayoutPercent / 100));
          }

          this.fkey++;
          this.rowKey++;
        }
      }
    }

    this.closeModal();
  }

  //when pricing model = relative
  //calculate all prices based on selling prices price differences
  autoCalculateFromOutputPrice(obr: OfficialRateRuleModel) {
    if (this.officialRateInternal) {
      for (const item of this.officialRateInternal?.officialRateRules) {
        //skip the main (obr)
        if (item !== obr) {
          let paxOutputPricePart = 0;
          let losOutputPricePart = 0;
          
          if (obr.price){
            if (
              item.obOutputPriceDifference &&
              obr.accomodationUnitTypesPAXCategoryId !== item.accomodationUnitTypesPAXCategoryId
            ) {
              paxOutputPricePart = item.obOutputPriceDifferenceIsAbsolute
                ? item.obOutputPriceDifference
                : round(obr.price * (item.obOutputPriceDifference / 100));
            }

            if (
              item.losOutputPriceDifference &&
              obr.accomodationUnitTypesLOSCategoryId !== item.accomodationUnitTypesLOSCategoryId
            ) {
              losOutputPricePart = item.losOutputPriceDifferenceIsAbsolute
                ? item.losOutputPriceDifference
                : round(obr.price * (item.losOutputPriceDifference / 100));
            }
          }

          const outputPriceSum = paxOutputPricePart + losOutputPricePart; // we do this because javascript is dumb :) (123,47 + (-12,35) + (-12,35) = 98,770000000000001 BUT 123,47 + (-24,7) = 98,77)
          item.price = round((obr.price ?? 0) + outputPriceSum); // rounding just to avoid further unexpected behavior.

          const ownerPayoutPercent = this.accUnitType?.propertyOwnerPayoutPercent ?? 0;
          item.inputPrice = round(item.price * (ownerPayoutPercent / 100));

          this.fkey++;
          this.rowKey++;
        }
      }
    }

    this.closeModal();
  }

  closeModal() {
    this.automaticCalculationModal = false;
  }
}
